<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <GroupConfiguration
        :groupNameInputDisabled="false"
        :parentType="parentType"
      />
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import GroupConfiguration from 'client/groups/Components/GroupConfiguration.vue';

const mdmSettingsModel = StoreModelMap[ItemTypeConsts.mdmSettings];
const deviceGroupModel = StoreModelMap[ItemTypeConsts.systemGroup];

export default {
  name: 'SystemGroupDetails',

  inject: ['$validator'],

  components: {
    DetailsAsideLayout,
    GroupConfiguration,
  },

  data() {
    return {
      parentType: ItemTypeConsts.systemGroup,
    };
  },

  computed: {
    ...mapState(mdmSettingsModel, {
      DEPdeviceSetupSettings: 'item',
    }),

    ...mapState(deviceGroupModel, {
      deviceGroup: 'item',
    }),

    isDEPDefaultGroup() {
      return (get(this.DEPdeviceSetupSettings.mdmDevices[0], 'defaultSystemGroupID') === this.deviceGroup.id);
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(mdmSettingsModel, [
      'fetchMdmSettings',
    ]),

    async handleMounted() {
      await this.fetchMdmSettings();
    },
  },
};
</script>
